// extracted by mini-css-extract-plugin
export default {"button":"Button_button__n0lDA","primary":"Button_primary__AejsX","cancel":"Button_cancel__8eTrq"};